






































































































































































import { inject } from "inversify-props";
import { Component, Vue } from "vue-property-decorator";
import { center as centerStore } from "@/store/modules";
import CenterEditor from "@/components/CenterEditor.vue";
import { CenterModel } from "@/models/center";
import { ICenterService } from '@/interfaces/Services';
import DependencyIdentifiers from '@/ioc/DependencyIdentifiers';
import { auth } from '@/store/modules';

@Component({
  components: {
    CenterEditor
  }
})
export class Centers extends Vue {
  @inject(DependencyIdentifiers.CenterService)
  private centerService!: ICenterService;

  private addNew = false;
  private componentKey = 0;
  private async refresh() {
    this.isLoading = true;
    try {
      let size = 100,
        page = 1,
        total = 0;
      do {
        const [items, {}] = await this.centerService.getMany(page, size);
        this.items = [...items];
      } while (page * size < total);
    } finally {
      this.isLoading = false;
    }
  }

  onOpenCreate() {
    this.addNew = true;
    this.selected = [];
  }

  openEditor(id: string) {
    for (const item of this.items) {
      if (item.$id === id) {
        this.selected = [item];
        return;
      }
    }
  }

  async goto(path: string, $id: string) {
    await auth.setCenterId($id);
    this.$router.push({path});
  }

  async onSelect() {
    this.addNew = false;
  }

  async onCancel() {
    this.addNew = false;
    this.selected = [];
  }

  async onCreated(model: CenterModel) {
    await this.refresh();
    this.addNew = false;
    this.selected = [model];
  }

  private selected: CenterModel[] = [];
  private get headers() {
    return [
      {
        text: this.$t('center.fields.name'),
        align: "left",
        sortable: true,
        value: "name"
      },
      {
        text: this.$t('center.fields.onDutyPhone'),
        align: "left",
        sortable: false,
        value: "onDutyPhone"
      },
      {
        text: "",
        value: "action",
        sortable: false,
        align: "right"
      }
    ];
  }

  private isLoading = true;
  private items: Array<any> = [];
  private search: string = "";

  async mounted() {
    // TODO: This should not be here but handled by route middleware instead.
    if (!auth.isPrimaryCenter) {
      this.$router.push({path: '/dashboard/patients'});
    }
    this.refresh();
  }
}

export default Centers;
